/**
 * Firebase Configuration and Initialization
 * 
 * This file sets up Firebase for the application.
 * Firebase is a Backend-as-a-Service (BaaS) platform that provides:
 * - Firestore: NoSQL database for storing data
 * - Authentication: User management
 * - Storage: File storage
 * - And more...
 * 
 * Think of Firebase like a cloud-based backend that you can use
 * without writing server code yourself!
 */

/**
 * Firebase Configuration and Initialization
 * 
 * This file sets up Firebase for the application.
 * Firebase is a Backend-as-a-Service (BaaS) platform that provides:
 * - Firestore: NoSQL database for storing data
 * - Authentication: User management
 * - Storage: File storage
 * - Analytics: User behavior tracking
 * - And more...
 * 
 * Think of Firebase like a cloud-based backend that you can use
 * without writing server code yourself!
 */

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration object
// These values identify your Firebase project (sagar-ventures)
// Note: Firebase API keys in frontend config are safe to expose - security is enforced via Firebase Security Rules
const firebaseConfig = {
  apiKey: "AIzaSyAJZbnIf_M3jS2HEBfzRSZCIr7XdFwq1UM",
  authDomain: "sagar-ventures.firebaseapp.com",
  projectId: "sagar-ventures",
  storageBucket: "sagar-ventures.firebasestorage.app",
  messagingSenderId: "248369532072",
  appId: "1:248369532072:web:3b69773dd56079d0eb069d",
  measurementId: "G-PG73W6XQNZ",
};

// Initialize Firebase
// This connects your app to your Firebase project
const app = initializeApp(firebaseConfig);

// Initialize Firestore
// Firestore is Firebase's database - like a cloud-based spreadsheet
// where each row is a "document" and each sheet is a "collection"
const db = getFirestore(app);

// Initialize Analytics (only in browser environment)
// Analytics tracks user behavior and app usage
// We check if window exists because Analytics only works in the browser, not in Node.js (like during build)
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    // Analytics might fail in development or if not properly configured
    console.warn('Firebase Analytics initialization failed:', error);
  }
}

// Initialize Firebase Functions
// Functions are server-side code that runs in Firebase's cloud
// Think of it as a secure server where you can store API keys and secrets
// This connects your React app to your Firebase Functions backend
const functions = getFunctions(app);

// Connect to Firebase Functions emulator in development
// This allows you to test functions locally without deploying
// The emulator runs on localhost:5001 by default
// To use the emulator, set REACT_APP_USE_FUNCTIONS_EMULATOR=true in your .env file
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true') {
  // connectFunctionsEmulator connects to the local emulator
  // Format: host, port
  // Default Firebase Functions emulator runs on localhost:5001
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    console.log('🔧 Connected to Firebase Functions emulator');
  } catch (error) {
    // Emulator might already be connected, which is fine
    console.warn('Functions emulator connection:', error.message);
  }
}

// Create a callable function reference for the chat function
// This is like creating a phone number you can call to talk to your server
// The 'chat' name matches the function exported in functions/index.js
// httpsCallable creates a function you can call from React that securely communicates with Firebase Functions
export const chatFunction = httpsCallable(functions, 'chat');

export { db, app, analytics, functions };
